import { useRef, useState } from 'react'

function clamp(value, minimum, maximum) {
  return Math.min(Math.max(value, minimum), Math.max(minimum, maximum))
}

export default function FloatingOptionChainWindow({ ariaLabel, children }) {
  const panelRef = useRef(null)
  const dragRef = useRef(null)
  const [position, setPosition] = useState(null)

  const handlePointerDown = (event) => {
    if (event.button !== 0 || window.innerWidth < 768) return
    if (!event.target.closest('[data-option-chain-drag-handle]') || event.target.closest('button, a, input, select, textarea')) return
    const rect = panelRef.current?.getBoundingClientRect()
    if (!rect) return
    dragRef.current = {
      pointerId: event.pointerId,
      offsetX: event.clientX - rect.left,
      offsetY: event.clientY - rect.top,
    }
    event.currentTarget.setPointerCapture?.(event.pointerId)
    event.preventDefault()
  }

  const handlePointerMove = (event) => {
    const drag = dragRef.current
    const panel = panelRef.current
    if (!drag || !panel || drag.pointerId !== event.pointerId) return
    const rect = panel.getBoundingClientRect()
    setPosition({
      x: clamp(event.clientX - drag.offsetX, 0, window.innerWidth - rect.width),
      y: clamp(event.clientY - drag.offsetY, 0, window.innerHeight - rect.height),
    })
  }

  const stopDragging = (event) => {
    if (dragRef.current?.pointerId !== event.pointerId) return
    dragRef.current = null
    event.currentTarget.releasePointerCapture?.(event.pointerId)
  }

  return (
    <div data-testid="asset-list-symbol-search-overlay" className="pointer-events-none fixed inset-0 z-[70]">
      <div
        ref={panelRef}
        role="dialog"
        aria-modal="false"
        aria-label={ariaLabel}
        data-testid="floating-option-chain-window"
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={stopDragging}
        onPointerCancel={stopDragging}
        className="pointer-events-auto absolute h-[min(36rem,calc(100vh-2rem))] min-h-[20rem] w-[min(72rem,calc(100vw-2rem))] min-w-[44rem] resize overflow-hidden rounded-lg border border-border bg-canvas text-ink shadow-2xl max-md:!inset-2 max-md:!h-[calc(100vh-1rem)] max-md:!w-[calc(100vw-1rem)] max-md:!min-w-0 max-md:!translate-x-0 max-md:!resize-none"
        style={position
          ? { left: position.x, top: position.y }
          : { left: '50%', top: 'max(1rem, 6vh)', transform: 'translateX(-50%)' }}
      >
        {children}
      </div>
    </div>
  )
}
